module.exports = __webpack_public_path__ + "static/media/default-profile.7be6363e.svg";